export const HERO_VIDEO_SRC = "/videos/settrhq-vsl-landscape.mp4";
export const HERO_VIDEO_POSTER = "/videos/settrhq-vsl-landscape-preview.png";
export const VIDEO_WATCH_MILESTONES = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

export const MADE_BY_VIDEO_TABS = [
  {
    id: "founder",
    label: "Made by Roofers",
    subtitle: "Founder Breakdown (60s)",
    src: HERO_VIDEO_SRC,
    poster: HERO_VIDEO_POSTER,
    chromeTitle: "Founder Breakdown",
    playLabel: "Play Founder Breakdown video",
  },
  {
    id: "interception",
    label: "Live 26-Sec Interception Demo",
    subtitle: null,
    src: "/videos/settrhq-demo-86s-landscape.mp4",
    poster: "/videos/settrhq-demo-86s-landscape-preview.png",
    chromeTitle: "26-Sec Interception Demo",
    playLabel: "Play 26-second interception demo",
  },
];
